const Contact = () => {
  return (
    <div style={{ padding: "1rem 0" }}>
      <h2>Contact</h2>
    </div>
  );
};

export default Contact;
